/* src/app/views/display/components/edit-display/edit-display-details/edit-display-details.component.scss */
.url-container {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1rem;
}
/*# sourceMappingURL=edit-display-details.component.css.map */
